<template>
  <card class="card">
    <div class="card-body">
      <h2 class="pt-0 mt-0">
        <i class="fas fa-wrench text-primary"></i>{{$t('asf.titleadd')}}
      </h2>
      <hr>
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <fg-input type="text" :label="$t('asf.name')" :placeholder="$t('asf.name')" v-model="asf.name"></fg-input>
            </div>
            <div class="col-md-6">
              <fg-input type="text" :label="$t('asf.cnpj')" :placeholder="$t('asf.cnpj')" v-model="asf.vat"></fg-input>
            </div>

            <h5 class="text-muted col-md-12">Certificado</h5>

            <div class="col-md-2">       
              <b-form-checkbox
                id="asf-certified"
                v-model="asf.certified"
                name="asf-certified"
                value="1"
                v-on:click="linkPart"
                unchecked-value="0"
              >
               <label for="asf-certified">ASF Certificada</label>
              </b-form-checkbox>
            </div>

            <div class="col-md-2">
              <div>
                Pontuação média:
              </div> 
              <div v-for="star in generateRate()" style="width:24px; height: auto;" class="d-inline-block align-middle">
                <img :src="require('@/assets/img/'+ star)" alt="">
              </div>
              <label class="pl-2 pt-2 align-middle">
                {{ calcGrade() }}
              </label>
            </div>


            <div class="col-md-3">              
               <b-form-datepicker
                  id="datepicker-initial_date"
                  v-model="asf.initial_date"
                  class="m-0 p-0"
                  size="sm"
                  :max="max_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :dark=true
                  :placeholder="$t('dashboard.select_date')"
                ></b-form-datepicker>
            </div>

            <div class="col-md-3">
              <b-form-datepicker
                  id="datepicker-expiry_date"
                  v-model="asf.expiry_date"
                  class="m-0 p-0"
                  size="sm"
                  :max="max_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :dark=true
                  :placeholder="$t('dashboard.select_date')"
                ></b-form-datepicker>
            </div>
            
            <div class="col-md-2">
                <button
                    class="btn btn-primary"
                    type="button"
                    v-if="checkExpiryDate()"  
                    @click="downloadCertified(asf.id)"
                >
                  <i class="fas fa-download"></i>
                  Baixar Certificado
                </button>
                <button
                    class="btn btn-default"
                    style="cursor: default"
                    disabled
                    type="button"
                    v-else
                >
                  <i class="fas fa-download"></i>
                  Certificado expirado
                </button>
            </div>
          </div>
          <fg-address v-model="asf.addresses" multiple="true"></fg-address>
          <fg-phone v-model="asf.phones" multiple="true"></fg-phone>
          <div class="text-left">
            <p-button type="primary" @click.native.prevent="updateAsf">{{$t('asf.button.save')}}</p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </div>
  </card>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("asfs", {
      asf: "asf"
    })
  },
  beforeCreate() {
    this.$store.dispatch("asfs/getAsf", this.$route.params.id);
  },
  methods: {
    calcGrade() {
      let finalGrade = 0;
      let stars = 0;
      if(this.asf.answers.length != 0){
        this.asf.answers.forEach((answer) => { 
          finalGrade += answer.final_grade;
        });
        stars = parseFloat(5*(finalGrade/this.asf.answers.length)/100).toFixed(1);
      }
      return stars;
    },
    generateRate() {
      const img_name = "rating-star-";
      const img_ext = ".svg";
      let stars = this.calcGrade();
      const star_rating = Array(5).fill(img_name + 'void' + img_ext);
      const [full_stars, remnant] = stars.toString().split('.');

      star_rating.fill(img_name + 'full' + img_ext, 0, full_stars);

      if (remnant >= 5 ) {
        star_rating[full_stars] = img_name + 'half' + img_ext;
      }
      // console.log(star_rating);
      return star_rating;
    },
    checkExpiryDate(){
      
      let valid = true;
      let initial = new Date(this.asf.initial_date);
      let end = new Date(this.asf.expiry_date);
      let now = Date.now();
      
      if ( new Date(now) < initial || new Date(now) > end ) {
        valid = false;
      }

      return valid;
    },
    downloadCertified(asf_id){
      let pdf = this.$store.dispatch("asfs/downloadCertified", asf_id);     
    },
    updateAsf() {
      this.$store
        .dispatch("asfs/editAsfs", this.asf)
        .then(response => {
          this.$router.push({ name: "asfs" });
          this.$notify({
            type: "success",
            message: this.$t('asf.message.successupdate')
          });
        })
        .catch(error => {
          this.$notify({
            type: "danger",
            message: "Error! Try again."
          });
        });
    }
  }
};
</script>
<style>
</style>
